import { render } from "./ComparableValueDrawer.vue?vue&type=template&id=2e716bc3&scoped=true"
import script from "./ComparableValueDrawer.vue?vue&type=script&lang=js"
export * from "./ComparableValueDrawer.vue?vue&type=script&lang=js"

import "./ComparableValueDrawer.vue?vue&type=style&index=0&id=2e716bc3&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e716bc3"]])

export default __exports__